import { Pipe, PipeTransform } from '@angular/core';
import { InstallationYesNoPluginService } from './yes-no.service';
@Pipe({
    name: 'yesnostatus',
    standalone: false
})
export class YesNoStatusPipe implements PipeTransform {
  public statuses: any[];
  constructor(private service: InstallationYesNoPluginService) {
    this.statuses = this.service.getStatuses();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.statuses);
  }
}
